const flexDashboardGlobalSettings = {
    global: {
        splitterSize: 4,
        tabClassName: 'flex-dashboard--tab',
        tabEnableClose: false,
        tabEnableRename: false,
        tabSetHeaderHeight: 24,
        tabSetTabStripHeight: 24,
    },
};

export default function getDashboardConfig(dashboardConfig) {
    return {...flexDashboardGlobalSettings, ...dashboardConfig};
}
